function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Star Filled Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M17.4785,6.6368 C17.4195,6.4558 17.2625,6.3238 17.0755,6.2968 L11.8055,5.5308 L9.4495,0.7568 C9.2815,0.4148 8.7205,0.4148 8.5525,0.7568 L6.1965,5.5308 L0.9275,6.2968 C0.7405,6.3238 0.5825,6.4558 0.5245,6.6368 C0.4655,6.8178 0.5145,7.0158 0.6515,7.1488 L4.4635,10.8658 L3.5625,16.1128 C3.5305,16.3008 3.6075,16.4898 3.7615,16.6018 C3.8485,16.6648 3.9525,16.6978 4.0555,16.6978 C4.1355,16.6978 4.2145,16.6788 4.2885,16.6398 L9.0005,14.1628 L13.7135,16.6398 C13.8815,16.7278 14.0855,16.7138 14.2405,16.6018 C14.3945,16.4898 14.4715,16.3008 14.4395,16.1128 L13.5395,10.8658 L17.3515,7.1488 C17.4885,7.0158 17.5375,6.8178 17.4785,6.6368",
  id: "star-filled-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "star-filled-Icon/Global/Star-filled",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "star-filled-Swatches/DarkGreen",
  transform: "translate(3.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "star-filled-Mask",
  fill: "currentcolor",
  xlinkHref: "#star-filled-path-1"
})));

var SvgStarFilled = function SvgStarFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star-filled.e522c179.svg";
export { ForwardRef as ReactComponent };